import { markdownToHtml } from "@perxis-auto/shared";
import { createEntityAdapter } from "@reduxjs/toolkit";
import { createAppSelector } from "../../shared/lib/store/createAppSelector.js";
const { selectAll, selectById, selectEntities, selectIds, selectTotal } = createEntityAdapter().getSelectors((state) => state.stages);
const selectState = (state) => state.stages;
const selectCurrent = createAppSelector(selectState, (stagesState) => stagesState.current);
const selectService = createAppSelector(selectState, (stagesState) => {
  if (!stagesState.service) {
    return stagesState.service;
  }
  return {
    ...stagesState.service,
    ...stagesState.service.description && {
      description: markdownToHtml(stagesState.service.description)
    },
    ...stagesState.service.disclaimer_text && {
      disclaimer_text: markdownToHtml(stagesState.service.disclaimer_text)
    }
  };
});
const selectCurrentEntity = createAppSelector(
  selectState,
  (stagesState) => stagesState.current && stagesState.entities[stagesState.current] || null
);
const selectError = createAppSelector(selectState, (stagesState) => {
  return stagesState.error;
});
const selectLoading = createAppSelector(selectState, (stagesState) => stagesState.loading);
const selectByFormId = createAppSelector(
  [(_, { formId }) => formId, selectAll],
  (formId, stages) => stages.find((stage) => stage.form.id === formId) || null
);
const selectAllFields = createAppSelector(selectAll, (stages) => {
  const fieldIds = /* @__PURE__ */ new Set();
  return stages.flatMap((stage) => stage.form.groups.flatMap(({ fields }) => fields)).filter((field) => {
    if (fieldIds.has(field.id)) {
      return false;
    }
    fieldIds.add(field.id);
    return true;
  });
});
const selectAllFieldsByFormId = createAppSelector(
  selectByFormId,
  (stage) => (stage == null ? void 0 : stage.form.groups.flatMap((group) => group.fields)) || null
);
const selectFieldById = createAppSelector(
  [(_, { fieldId }) => fieldId, selectAllFieldsByFormId],
  (fieldId, fields) => (fields == null ? void 0 : fields.find((field) => field.id === fieldId)) || null
);
export {
  selectAll,
  selectAllFields,
  selectAllFieldsByFormId,
  selectByFormId,
  selectById,
  selectCurrent,
  selectCurrentEntity,
  selectEntities,
  selectError,
  selectFieldById,
  selectIds,
  selectLoading,
  selectService,
  selectState,
  selectTotal
};
